import { useEffect } from 'react';

import {
    PAYROLL_PRIMER_SOCIAL_TRUST_API_NAME,
    PAYROLL_PRIMER_SOCIAL_TRUST_STORE_NAME,
} from '@perpay-web/constants/src/experiments';
import { createDataModuleAdapter } from '@perpay-web/data-module/src/composeDataModules';
import { createDataModuleActions } from '@perpay-web/data-module/src/createDataModuleActions';
import { getIsLoadingOrUnrequested } from '@perpay-web/data-module/src/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/src/useReduxDataModuleHookConnection';
import {
    getIsUserExistedInGroup,
    getIsUserInTestGroup,
    useABTestDataModule,
} from '@perpay-web/hooks/abTests/useABTestDataModule';
import { hookAction$ } from '@perpay-web/services/singletons';

const dataModuleFetchActions = createDataModuleActions(
    'FETCH_PAYROLL_PRIMER_SOCIAL_TRUST_AB_TEST',
);
const fetchPayrollPrimerSocialTrustABTest = dataModuleFetchActions.dataRequest;
const fetchPayrollPrimerSocialTrustABTestSuccess =
    dataModuleFetchActions.dataSuccess;
const fetchPayrollPrimerSocialTrustABTestError =
    dataModuleFetchActions.dataError;
const fetchPayrollPrimerSocialTrustABTestReset =
    dataModuleFetchActions.dataReset;

export const usePayrollPrimerSocialTrustABTest = () => {
    const dataModule = useABTestDataModule();
    const { state, dataRequest } = dataModule;

    const isLoading = getIsLoadingOrUnrequested(state);
    const isUserInTestGroup = getIsUserInTestGroup(
        state,
        PAYROLL_PRIMER_SOCIAL_TRUST_STORE_NAME,
    );
    const isUserExistedInGroup = getIsUserExistedInGroup(state);

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: fetchPayrollPrimerSocialTrustABTest,
        success: fetchPayrollPrimerSocialTrustABTestSuccess,
        error: fetchPayrollPrimerSocialTrustABTestError,
        reset: fetchPayrollPrimerSocialTrustABTestReset,
    });

    useEffect(() => {
        if (window.STORYBOOK) return;
        dataRequest(PAYROLL_PRIMER_SOCIAL_TRUST_API_NAME);
    }, [dataRequest]);

    return {
        isLoading,
        isUserInTestGroup,
        isUserExistedInGroup,
    };
};

export const usePayrollPrimerSocialTrustABTestAdapter = createDataModuleAdapter(
    fetchPayrollPrimerSocialTrustABTest,
    fetchPayrollPrimerSocialTrustABTestSuccess,
    fetchPayrollPrimerSocialTrustABTestError,
);
